/* Copyright (c) 2020 CLOUDPILOTS Software & Consulting GmbH */

import {
  NotificationManager,
  PageLoader,
  Wrapper,
} from '@cloudpilots/components';
import { makeStyles } from '@material-ui/core';
// TODO API: Uncomment if you use api hook
// import { useApi } from 'hooks/api';
import PropTypes from 'prop-types';
import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { config, menu, routes, scopes } from '../config';

const useStyles = makeStyles(() => ({
  loginLogo: {
    width: 56,
    marginBottom: 8,
  },
}));

const Content = (props) => {
  const classes = useStyles();
  // TODO API: Uncomment if you use api hook
  // const Api = useApi();
  return (
    <Suspense fallback={<PageLoader isLoading hasColor isFixed />}>
      <Router>
        <Wrapper
          // TODO API: Uncomment if you use api hook
          // isReady={Api.isInitialized}
          isReady
          appName={config.appName}
          routes={routes}
          scopes={scopes}
          menu={menu}
          viewProps={{
            notify: (...args) => NotificationManager.notify(...args),
          }}
          onDidMount={() => {}}
          noMenu
          noAppBar
          CustomLogo={
            <img
              src='/images/logo.svg'
              alt='logo'
              className={classes.loginLogo}
            />
          }
          {...props}
        />
      </Router>
    </Suspense>
  );
};

Content.propTypes = {
  children: PropTypes.any,
};

export default Content;
